module.exports = __webpack_public_path__ + "static/media/small-placeholder.9341ae63.svg";